<span class="color-point" [style.background-color]="item.fillStyle">
  @if (!item.hidden) {
    <i class="myre-icon-check"> </i>
  }
</span>

<span ellipsis class="label">{{ item.text }}</span>
